import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ProductList = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [toastMessage, setToastMessage] = useState("");
  const userID = localStorage.getItem("userID");

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await fetch(
          "https://xianhefairy.com/LotusFairy_API/api/member/getProduct"
        );
        const data = await res.json();
        const productList = data || [];
        const foundProduct = productList.find((p) => p.ID.toString() === id);
        // If navigation state contains an image, attach it to the found product for immediate display
        if (foundProduct) {
          const navImage = location?.state?.image;
          if (navImage) foundProduct.ImageUrl = navImage;
        }
        setProduct(foundProduct);
      } catch (err) {
        setError("Error fetching product");
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  const getImageSrc = (product) => {
    // Prefer an explicit ImageUrl (from nav state or API), else fallback to legacy static path
    if (!product) return "";
    if (product.ImageUrl) return product.ImageUrl;
    if (product.ImageProdId && product.ImageFile) {
      // If API provides ImageProdId/ImageFile, build path if necessary (fall back behavior)
      return product.ImageUrl || `/static/media/product/${product.ImageProdId.toString().padStart(5, 0)}/${product.ImageFile}`;
    }
    if (product.FILENAME && product.ID)
      return `/static/media/product/${product.ID.toString().padStart(5, 0)}/${product.FILENAME}.png`;
    return "";
  };

  const fetchCart = async () => {
    const res = await fetch(
      `https://xianhefairy.com/LotusFairy_API/api/booking/getCart?ID=${userID}`
    );
    const result = await res.json();

    if (!Array.isArray(result) || result.length === 0) {
      return {
        UID: null,
        cart: [],
        createdBy: userID,
        updatedBy: userID,
      };
    }

    const cartEntry = result[0];
    const parsedCart = cartEntry?.CART ? JSON.parse(cartEntry.CART) : [];

    return {
      UID: cartEntry?.UID || null,
      cart: parsedCart,
      createdBy: cartEntry?.CREATED_BY || userID,
      updatedBy: cartEntry?.UPDATE_BY || userID,
    };
  };

  const showToast = (message) => {
    setToastMessage(message);
    setTimeout(() => {
      setToastMessage("");
    }, 3000); // hides after 3 seconds
  };

  const addToCart = async (product) => {
    if (userID) {
      try {
        const payload = {
          Uid: "",
          CustId: Number(userID),
          Qty: 1,
          ProdId: product.ID, // Use product.ID from your API
          ProdDesc: product.DESC_OTH || product.DISPLAY_NAME || product.FILENAME || "",
        };

        console.log("Add to cart payload:", payload);

        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/Usercart/UserCartUpdate`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );

        const result = await response.json();
        console.log("API response:", result);

        if (result.successful) {
          showToast(result.save_msg || t('productListPage.added'));

          // ✅ Dispatch event for same tab
          window.dispatchEvent(new CustomEvent('cartUpdated'));

          // ✅ Update localStorage to trigger event in other tabs
          localStorage.setItem('cartUpdatedAt', Date.now().toString());
        } else {
          showToast(result.return_err || "Failed to add to cart.");
          console.error("Add to cart failed:", result);
        }
      } catch (error) {
        console.error("Error adding to cart:", error);
        showToast("Error adding to cart.");
      }
    } else {
      navigate("/main");
      alert("You need to log in before placing an order.");
    }
  };
  // const addToCart = async (product) => {
  //   if (userID) {
  //     const isLoggedIn = localStorage.getItem("isLoggedIn");
  //     if (isLoggedIn !== "true") {
  //       alert("You need to login first before accessing this page");
  //       return;
  //     }

  //     const token = "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp";

  //     try {
  //       const { UID, cart, createdBy, updatedBy } = await fetchCart();

  //       const updatedCart = [...cart];
  //       const index = updatedCart.findIndex(
  //         (item) => item.Product_ID === product.ID
  //       );

  //       if (index !== -1) {
  //         updatedCart[index].Quantity += 1;
  //       } else {
  //         updatedCart.push({
  //           Product_ID: product.ID,
  //           Quantity: 1,
  //         });
  //       }

  //       const requestBody = {
  //         UID,
  //         CustomerID: userID,
  //         CartData: updatedCart,
  //         CreatedBy: createdBy || userID,
  //         UpdatedBy: updatedBy || userID,
  //         Status: 0,
  //       };

  //       const response = await fetch(
  //         `https://xianhefairy.com/LotusFairy_API/api/booking/AddCart?token=${token}`,
  //         {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify(requestBody),
  //         }
  //       );

  //       const result = await response.json();
  //       console.log("Updated cart body sent:", requestBody);
  //       console.log("API response:", result);

  //       if (!response.ok) {
  //         console.error("Failed to update cart:", result);
  //       } else {
  //         showToast(
  //           `${
  //             product.DESC_OTH
  //           } added to cart.`
  //         );
  //       }
  //       // ✅ Dispatch custom event to notify header
  //       window.dispatchEvent(new CustomEvent('cartUpdated'));
  //     } catch (error) {
  //       console.error("Error adding to cart:", error);
  //     }
  //   } else {
  //     alert("You need to login first before accessing this page");
  //   }
  // };

  if (loading) return <p>{t('productListPage.loading')}</p>;
  if (error) return <p>{error}</p>;
  if (!product) return <p>{t('productListPage.productNotFound')}</p>;

  return (
    <div>
      <div style={styles.container}>
        <button style={styles.closeButton} onClick={() => window.history.back()}>
          ✕
        </button>
        <div style={styles.titleContainer}>
          <h2 style={styles.title}>
            {(product.DESC_OTH || product.DESC_ENG || product.DISPLAY_NAME || product.FILENAME)
              .split('\n')
              .map((line, idx, arr) => (
                <React.Fragment key={idx}>
                  {line}
                  {idx < arr.length - 1 && <br />}
                </React.Fragment>
              ))}
          </h2>
        </div>
        <div style={styles.imageContainer}>
          <img
            src={getImageSrc(product)}
            alt={product.FILENAME}
            style={styles.productImage}
          />
        </div>
        <p style={styles.remark}>{product.REMARK || product.DESCRIPTION}</p>
        {/* <p style={styles.price}>{t('productListPage.cost')}: US$ {product.CASH_AMT} || {t('productListPage.gems')}: {product.OTHER_AMT}</p> */}

        <div style={styles.buttonContainer}>
          <button style={styles.button} onClick={() => addToCart(product)}>
            {t('productListPage.addToCart')}
          </button>
        </div>
      </div>
      
      {toastMessage && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#10b981",
            color: "#fff",
            padding: "12px 20px",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            zIndex: 11000,
            transition: "opacity 0.3s ease-in-out",
          }}
        >
          {toastMessage}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: "20px",
    maxWidth: "600px",
    height: "auto",
    minHeight: "60vh",
    maxHeight: "90vh",
    margin: "0 auto",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#212121",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    marginTop: "5%",
    marginBottom: "5%",
    position: "relative",
    overflow: "auto",
    paddingBottom: "30px",
  },
  closeButton: {
    position: "absolute",
    top: "20px",
    right: "20px",
    backgroundColor: "transparent",
    border: "2px solid #DFBD69",
    color: "#DFBD69",
    fontSize: "20px",
    fontWeight: "bold",
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",
    zIndex: 10,
    padding: "0",
  },
  titleContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "10px",
    paddingTop: "5px",
  },
  title: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#DFBD69",
    textAlign: "center",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    lineHeight: "1.3",
    maxWidth: "85%",
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "15px",
    height: "250px",
    width: "100%",
  },
  productImage: {
    maxWidth: "100%",
    height: "auto",
    borderRadius: "8px",
    transition: "transform 0.3s ease",
  },
  remark: {
    fontSize: "14px",
    color: "#dfbd69",
    marginBottom: "8px",
    textAlign: "center",
  },
  category: {
    fontSize: "14px",
    color: "#dfbd69",
    marginBottom: "8px",
    textAlign: "center",
  },
  price: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#DFBD69",
    textAlign: "center",
    marginBottom: "15px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "15px",
    marginBottom: "10px",
  },
  button: {
    padding: "10px 20px",
    backgroundColor: "#DFBD69",
    color: "#000",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
  },
  message: {
    marginTop: "10px",
    color: "white",
  },
};

export default ProductList;
